import React, { useState } from 'react'
import { Card, CardHeading, CardContent } from '@components/layout/Card'
import { Grid } from '@components/layout/Grid'
import styles from "./loading-state.module.sass"
import { Button } from '@components/Button'
import { useReminderRequestMutation } from '@api/useReminderRequestMutation'
import { track } from '@utils/tracking'
import { useOrganizationOnboardingStatusQuery } from '@api/useOrganizationOnboardingStatusQuery'

export const LoadingState = ({ organization_id }) => {
  const [reminderRequested, setReminderRequested] = useState(false);

  const { data, status, error } = useOrganizationOnboardingStatusQuery(organization_id);
  const onboarded = data?.onboardedCount ?? 0;
  const total = data?.total ?? 0;

  const { mutate: createReminderRequest } = useReminderRequestMutation();

  const handleRemindMe = () => {
    track('Requested Organization Dashboard Reminder')

    createReminderRequest('organization_dashboard', {
      onSuccess: () => {
        setReminderRequested(true);
      },
      onError: (err) => {
        console.error('Error creating reminder request:', err);
      }
    })
  }

  if (status === 'loading') {
    return <p>Loading onboarding data...</p>;
  }

  if (status === 'error') {
    return <p>Error fetching onboarding data: {error.message}</p>;
  }

  return (
    <div className={styles.loadingStateLayout}>
      <h1>Waiting for more users</h1>

      <Grid className={styles.onboardingDetails}>
        <Card>
          <CardHeading>
            <h2>Onboarding</h2>
          </CardHeading>
          <CardContent>
            <h1>{onboarded} / {total}</h1>
            <p>employees onboarded</p>
          </CardContent>
        </Card>

        <p>
          Your dashboard will be available once 10 or more users have signed up so that the reporting
          aggregates are sufficiently anonymized. Reports are generated weekly, so please check back
          after the next reporting cycle for updated information.
        </p>
      </Grid>

      {!reminderRequested ? (
        <Button primary size="medium" onClick={handleRemindMe}>Remind me when it's ready</Button>
      ) : (
        <p>We will remind you when it's ready!</p>
      )}
    </div>
  )
}
